<form [formGroup]="form">
  <p-autoComplete
    [suggestions]="pravnaLicaSuggestions"
    formControlName="searchValue"
    (completeMethod)="searchPravnoLice($event)"
    (onSelect)="selectionChanged($event)"
    [placeholder]="ctrlPlaceholder"
    [appendTo]="parentCtrl"
    emptyMessage="Stranka nije pronađena"
    dropdownMode="current"
    [disabled]="ctrlDisabled"
  >
    <ng-template let-stranka pTemplate="item">
      <div class="stranka-item">
        <div>{{ stranka.naziv }}</div>
      </div>
    </ng-template>
  </p-autoComplete>
  <kodit-error-info-required
    [formCtrl]="formCtrl!"
  ></kodit-error-info-required>
</form>

